import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { ChevronDownIcon, ChevronUpIcon } from '@systemeio/icons';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateRowExpandToggleProps {
  expanded: boolean;
  onClick: () => void;
}
export const AffiliateRowExpandToggle = t0 => {
  const $ = _c(9);
  const {
    expanded,
    onClick
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("global.more");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== expanded) {
    t2 = expanded ? <ChevronUpIcon /> : <ChevronDownIcon />;
    $[2] = expanded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expanded || $[5] !== onClick || $[6] !== t1 || $[7] !== t2) {
    t3 = <Button variant="ghost-gray" size="icon-sm" aria-expanded={expanded} aria-label={t1} onClick={onClick} className="shrink-0">{t2}</Button>;
    $[4] = expanded;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};